import { render, staticRenderFns } from "./practices-filter.vue?vue&type=template&id=4f2a0722&"
import script from "./practices-filter.vue?vue&type=script&lang=ts&"
export * from "./practices-filter.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports